import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api";
import { AuthState } from "./authSlice";

export interface AwardsState {
  awardPoints: any;
}

interface SavePointsProps {
  partnerName: string;
  points: number;
}

const initialState: AwardsState = {
  awardPoints: {}
};


export const getAwards = createAsyncThunk(
  "awards/get",
  async (_, { getState }) => {
    const rootState: any = getState();
    const authState: AuthState = rootState.auth;
    
    const response = await api.post(
      "/rewards/getUserProgrammes",
      { user_id: authState.userId },
      {
        headers: {
          Authorization: `Bearer ${authState.token}`
        }
      }
    );
    return {...response.data, clientId: authState.clientId, source: authState.source};
  }
);

export const savePoints = createAsyncThunk(
  "awards/save",
  async ({ partnerName, points }: SavePointsProps, { getState }) => {
    const rootState: any = getState();
    const authState: AuthState = rootState.auth;
    const response = await api.post(
      "/rewards/add/userProgramme",
      {
        user_id: rootState.auth.userId,
        main_program: partnerName,
        accumulated_points: false,
        total_accumulated_points: points,
        on_update:
          rootState.awards.awardPoints[partnerName] === "" ||
          rootState.awards.awardPoints[partnerName] === null ||
          rootState.awards.awardPoints[partnerName] === undefined
            ? false
            : true,
        prev_mainProgram: partnerName
      },
      {
        headers: {
          Authorization: `Bearer ${rootState.auth.token}`
        }
      }
    );
    return {...response.data, clientId: authState.clientId, source: authState.source};
  }
);

export const awardsSlice = createSlice({
  name: "awards",
  initialState,
  reducers: {
    resetState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAwards.pending, (state) => {})
      .addCase(getAwards.fulfilled, (state, action) => {
        for (let i = 0; i < action.payload.data.length; i++) {
          const element = action.payload.data[i];
          state.awardPoints[element.main_program] =
            element.total_accumulated_points;
        }

        // analytics
        analytics.track("Get All User Rewards Points Results", {
          awardPoints: state.awardPoints,
          location: window.location.href,
          clientId: action.payload.clientId, 
          source: action.payload.source
        });
      })
      .addCase(getAwards.rejected, (state, action) => {
        console.log(action);
      })
      .addCase(savePoints.pending, (state) => {})
      .addCase(savePoints.fulfilled, (state, action) => {
        state.awardPoints[action.payload.programUpdated.main_program] =
          action.payload.programUpdated.total_accumulated_points;

        // analytics
        analytics.track("User Updated Award", {
          award_program: action.payload.programUpdated.main_program,
          award_program_points:
            state.awardPoints[action.payload.programUpdated.main_program],
          location: window.location.href,
          clientId: action.payload.clientId, 
          source: action.payload.source
        });
      })
      .addCase(savePoints.rejected, (state, action) => {
        console.log(action);
      });
  }
});
export const { resetState } = awardsSlice.actions;

export default awardsSlice.reducer;
